import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { LayoutService } from './core/services/layout.service';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';
import { KeycloakService } from 'keycloak-angular';
import { AuthService } from './shared/services/auth.service';
import Coloris from '@melloware/coloris';
Coloris.init();

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'meteeau-nappes-client';

  constructor(
    private layoutService: LayoutService, 
    private translateService: TranslateService, 
    private breakpointObserver: BreakpointObserver, 
    private router: Router,
    private primengConfig: PrimeNGConfig,
    private keycloakService: KeycloakService,
    private authService: AuthService
  ) {
    translateService.setDefaultLang('fr');
    // Utilise la langue stockée ou la langue par défaut
    const browserLang = translateService.getBrowserLang();
    if (browserLang) {
      translateService.use(browserLang.match(/en|fr/) ? browserLang : 'fr');
    }
  }

  ngOnInit(): void {
    this.layoutService.initialize();
    this.translateService.onLangChange.subscribe(event => {
      this.translate(event.lang);
    });
    // Initial language setting
    this.translate(this.translateService.currentLang || 'fr');
    if (this.authService.isUserLoggedIn()) {
      this.authService.loadUserInfo().subscribe();
    }
  }

  translate(lang: string) {
    this.translateService.use(lang);
    this.translateService.get('primeng').subscribe(res => this.primengConfig.setTranslation(res));
  }
}
